module.exports = __webpack_public_path__ + "static/AL.190207.COH.WEBW.Connect1-c5dd7fd14cb9ac7115e9bf2f2238aeb8.jpg";